import type { TAssistantKind } from '@/interfaces/assistant.interface';

/*
 * What differs between the proposal kinds (plan F2.3: changes of the menu
 * and of the inventory) is written as one `Record<TAssistantKind, …>` table
 * per place, so a kind added to the contract fails compilation until every
 * place says what it does for it, instead of silently reading as a change
 * of the menu.
 */

/** Every kind this bundle reads. */
const KNOWN_KINDS: Readonly<Record<TAssistantKind, true>> = {
  'menu.changes': true,
  'stock.changes': true,
};

function isKnownKind(value: unknown): value is TAssistantKind {
  return (
    typeof value === 'string' &&
    Object.prototype.hasOwnProperty.call(KNOWN_KINDS, value)
  );
}

/**
 * `value` when it is a kind this bundle knows; otherwise a change of the
 * menu: a card written before Phase 5 names none, and a newer Action API's
 * kind read by this bundle (plan F13) reads as before, never as an error.
 */
export function knownKind(value: unknown): TAssistantKind {
  return isKnownKind(value) ? value : 'menu.changes';
}

/** The entry of `table` for `kind`, read as `knownKind` says. */
export function ofKind<T>(
  table: Readonly<Record<TAssistantKind, T>>,
  kind: TAssistantKind | undefined
): T {
  return table[knownKind(kind)];
}

/** Whether a kind's changes are the inventory's (plan P5-3). */
const INVENTORY_KINDS: Readonly<Record<TAssistantKind, boolean>> = {
  'menu.changes': false,
  'stock.changes': true,
};

/**
 * Whether changes of `kind` change the inventory: the pages that show it
 * then follow their apply and undo (`STOCK_CHANGED_EVENT`).
 */
export function changesInventory(kind: TAssistantKind | undefined): boolean {
  return ofKind(INVENTORY_KINDS, kind);
}
